export default class utilsDate {
    static DateTime(props: any) {
        if (props === undefined || props === null) {
            return ""
        }

        var date = new window.Date(props);
        return date.toLocaleDateString('pt-br') + ' ' + date.toLocaleTimeString('pt-br');
    }

    static DateShort(props: any) {
        if (props === undefined || props === null) {
            return ""
        }

        var date = new window.Date(props);
        return date.toLocaleDateString('pt-br');
    }

    static DateTimeShort(props: any) {
        if (props === undefined || props === null) {
            return ""
        }

        var date = new window.Date(props);
        return date.toLocaleDateString('pt-br') + ' ' + date.toLocaleTimeString('pt-br').substring(0, 5);
    }

    static DateTimeSecond(props: any) {
        if (props === undefined || props === null) {
            return ""
        }

        var date = new window.Date(props);
        return date.toLocaleDateString('pt-br') + ' ' + date.toLocaleTimeString('pt-br').substring(0, 8);
    }

    static TimeShort(props: any) {
        if (props === undefined || props === null) {
            return ""
        }

        var date = new window.Date("01/01/2001 " + props);
        return date.toLocaleTimeString('pt-br').substring(0, 5);
    }

    static TimeShortByCompleteDate(props: any) {
        if (props === undefined || props === null) {
            return ""
        }

        var date = new window.Date(props);
        return date.toLocaleTimeString('pt-br').substring(0, 5);
    }

    static TimeByCompleteDate(props: any) {
        if (props === undefined || props === null) {
            return ""
        }

        var date = new window.Date(props);
        return date.toLocaleTimeString('pt-br').substring(0, 8);
    }

    static DateShortDatePicker(props: any) {
        if (props === "" || props === undefined || props === null) {
            return "";
        }
        return props.slice(0, 10);
    }

    static CurrentDate() {
        let data = new window.Date();
        let dia = data.getDate().toString();
        let diaF = (dia.length === 1) ? '0' + dia : dia;
        let mes = (data.getMonth() + 1).toString(); //+1 pois no getMonth Janeiro começa com zero.
        let mesF = (mes.length === 1) ? '0' + mes : mes;
        let anoF = data.getFullYear();
        return anoF + "-" + mesF + "-" + diaF;
    }

    static ConvertYYYYMMDDToDate(dateString: string) {
        return new Date(Number(dateString.split('-')[0]), Number(dateString.split('-')[1]) - 1, Number(dateString.split('-')[2]), 0, 0, 0)
    }

    static ConvertYYYYMMDDToDateTime(dateString: string) {
        let strDate = dateString.substring(0, 10).split('-');
        let strTime = dateString.substring(11, 19).split(':');
        return new Date(Number(strDate[0]), Number(strDate[1]) - 1, Number(strDate[2]), Number(strTime[0]), Number(strTime[1]), Number(strTime[2]));
    }

    static ConvertDateToStringYYYYMMDD(date: Date){
        return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0') 
    }
    static ConvertDateToStringYYYYMMDDTHHMMSS(date: Date){
        return utilsDate.ConvertDateToStringYYYYMMDD(date) + "T" + date.toLocaleTimeString('pt-br');
    }

    static ConvertDDMMYYYYtoYYYYMMDD(date: string){
        var split = date.split('/')
        return split[2] + '-' + split[1] + '-' + split[0]
    }

    static IntervalToMilliseconds(date: any[])
    {
        var milliByHours = date[0] * 60 * 60 * 1000;
        var milliByMinutes = date[1] * 60 * 1000;
        var milliBySeconds = date[2] * 1000;

        return milliByHours + milliByMinutes + milliBySeconds;
    }

    // Converte valores vindos de inputs (DateField salva como "yyyy-MM-dd 00:00:00") em Date.
    static ParseInputDate(value: Date | string | null): Date | null {
        if (!value) return null;
        if (value instanceof Date) return value;

        const parsed = new Date(value.replace(' ', 'T'));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    // Converte datas retornadas pela API (suporta dd/MM/yyyy, dd/MM/yyyy HH:mm[:ss] e ISO) em Date.
    static ParseApiDate(value: any): Date | null {
        if (!value) return null;
        if (value instanceof Date)
            return Number.isNaN(value.getTime()) ? null : value;

        if (typeof value !== 'string') {
            const parsed = new Date(value);
            return Number.isNaN(parsed.getTime()) ? null : parsed;
        }

        const dateText = value.trim();
        if (dateText === '') return null;

        const brDateMatch = dateText.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
        if (brDateMatch) {
            const day = Number(brDateMatch[1]);
            const month = Number(brDateMatch[2]) - 1;
            const year = Number(brDateMatch[3]);
            const hour = Number(brDateMatch[4] || 0);
            const minute = Number(brDateMatch[5] || 0);
            const second = Number(brDateMatch[6] || 0);

            const parsed = new Date(year, month, day, hour, minute, second);
            return Number.isNaN(parsed.getTime()) ? null : parsed;
        }

        const normalized = dateText.includes(' ') ? dateText.replace(' ', 'T') : dateText;
        const parsed = new Date(normalized);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }
}
